export const INSPIRATION_HUB_PATH = '/inspiration';

export const getInspirationCategoryPath = (termUid: string) => `${INSPIRATION_HUB_PATH}/${termUid}`;

/** Page 1 is the bare path, so it has a single URL. */
export const getInspirationPageHref = (path: string, page: number) =>
  page > 1 ? `${path}?page=${page}` : path;

/**
 * The page asked for in `?page=`, or null when it is not a whole number from 1
 * up. Missing means page 1.
 */
export const parseInspirationPage = (value: string | string[] | undefined): number | null => {
  if (value === undefined) {
    return 1;
  }

  const page = Number(Array.isArray(value) ? value[0] : value);

  return Number.isInteger(page) && page >= 1 ? page : null;
};
